import React from 'react';
import { MapPinOutlineIcon, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { getNotificationFill } from "../../../../utils/utils";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var ConnectionNotification = function ConnectionNotification(_ref) {
  var status = _ref.status,
    text = _ref.text;
  var fillColor = getNotificationFill(status);
  if (!fillColor) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx('notification-bar'),
    "data-t-id": "AddressRequestForm-ConnectionNotification"
  }, /*#__PURE__*/React.createElement(MapPinOutlineIcon, {
    fill: fillColor,
    size: "m"
  }), /*#__PURE__*/React.createElement(Text, {
    size: "size6-r"
  }, text[status]));
};